module.exports = __webpack_public_path__ + "img/icon-arrow-down.23f10f05.svg";